module.exports = __webpack_public_path__ + "img/google-docs.2c769f29.png";